import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Space: Site = {
  id: 'space',
  logo: 'svg/space.svg',
  label: 'Space',
  analyticsName: 'space',
  hostname: 'space.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
